const KYC_STATUS_LABELS = {
  KYC_INITIATED: "Initiated",
  KYC_COMPLETED: "Completed",
  LINK_EXPIRED: "Link Expired",
  WEBHOOK_RECEIVED: "Webhook Received",
  WEBHOOK_FAILED: "Webhook Failed",
  NOT_APPLIED: "Not Applied",
};

const KYC_STATUS_COLORS = {
  KYC_COMPLETED: "bg-[#ECFDF5] text-[#059669]",
  KYC_INITIATED: "bg-[#FEFCE8] text-[#A16207]",
  WEBHOOK_RECEIVED: "bg-[#EFF6FF] text-[#2563EB]",
  LINK_EXPIRED: "bg-[#FFF7ED] text-[#EA580C]",
  WEBHOOK_FAILED: "bg-[#FEF2F2] text-[#DC2626]",
  NOT_APPLIED: "bg-[#F1F5F9] text-[#64748B]",
};

const CARD_STATUS_LABELS = {
  CARD_ISSUED: "Card Issued",
  CARD_ISSUANCE_FAILED: "Card Issuance Failed",
  WALLET_ISSUED: "Wallet Issued",
  WALLET_ISSUANCE_FAILED: "Wallet Issuance Failed",
  ACCOUNT_LINKED: "Account Linked",
  ACCOUNT_LINKED_FAILED: "Account Linked Failed",
  NOT_APPLIED: "Not Applied",
};

const CARD_STATUS_COLORS = {
  CARD_ISSUED: "bg-[#ECFDF5] text-[#059669]",
  WALLET_ISSUED: "bg-[#ECFDF5] text-[#059669]",
  ACCOUNT_LINKED: "bg-[#F0FDFA] text-[#0D9488]",
  CARD_ISSUANCE_FAILED: "bg-[#FEF2F2] text-[#DC2626]",
  WALLET_ISSUANCE_FAILED: "bg-[#FEF2F2] text-[#DC2626]",
  ACCOUNT_LINKED_FAILED: "bg-[#FEF2F2] text-[#DC2626]",
  NOT_APPLIED: "bg-[#F1F5F9] text-[#64748B]",
};

const kycStatusBadge = (status) => {
  const key = status || "NOT_APPLIED";
  const badgeClass = KYC_STATUS_COLORS[key] || "bg-[#F1F5F9] text-[#334155]";
  const label = KYC_STATUS_LABELS[key] || key;

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold font-poppins ${badgeClass}`}>
      {label}
    </span>
  );
};

const cardStatusBadge = (status) => {
  const key = status || "NOT_APPLIED";
  const badgeClass = CARD_STATUS_COLORS[key] || "bg-[#F1F5F9] text-[#334155]";
  const label = CARD_STATUS_LABELS[key] || key;

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold font-poppins ${badgeClass}`}>
      {label}
    </span>
  );
};

export {
  KYC_STATUS_LABELS,
  CARD_STATUS_LABELS,
  kycStatusBadge,
  cardStatusBadge,
};
